import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'ordersPickingList';
export const ordersPickingListActions = makeActions(
  MODEL_NAME,
  'id',
  'order-batches',
);

export const getAllOrdersPickingList = ordersPickingListActions.getAll;
export const editOrdersPickingList = ordersPickingListActions.edit;
export const createOrdersPickingList = ordersPickingListActions.create;
export const getByIdOrdersPickingList = ordersPickingListActions.getDataById;
